import { render } from "./ActiveFilters.vue?vue&type=template&id=f1afc248&ts=true"
import script from "./ActiveFilters.vue?vue&type=script&lang=ts"
export * from "./ActiveFilters.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/mikesteer/Documents/web/ecom/HasBean/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__